module.exports = __webpack_public_path__ + "media/images/faces/male/36-679a762600c086347c7f3448d0bad1d7.jpg";